// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__-CYw3","content":"Empty_content__jHDix","text":"Empty_text__odhPc","button":"Empty_button__TeLzX"};